<template>
    <div>

      <b-modal hide-footer no-close-on-backdrop no-close-on-esc v-model="showQuotation" size="xl" title="Cotización" centered>
        <div  v-if="quotation" style="margin-top:-35px">
          <div class="row">
            <div class="col-sm-3">
              <span><small>Folio</small></span><br>
              <span style="margin-top: -25px"><strong>{{quotation.DocNum}}</strong></span> <br>
            </div>
            <div class="col-sm-3">
              <span><small>Fecha</small></span><br>
              <span style="margin-top: -25px"><strong>{{quotation.DocDate}}</strong></span> <br>
            </div>
            <div class="col-sm-3">
              <span><small>Vencimiento</small></span><br>
              <span style="margin-top: -25px"><strong>{{quotation.DocDueDate}}</strong></span> <br>
            </div>
            <div class="col-sm-3">
              <span><small>Agente de ventas</small></span><br>
              <span style="margin-top: -25px"><strong>{{quotation.SalesPerson.SalesEmployeeName}}</strong></span> <br>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-9">
              <span><small>Cliente</small></span><br>
              <span style="margin-top: -25px"><strong>{{quotation.CardName}} | {{quotation.CardCode}}</strong></span> <br>
            </div>
            <div class="col-sm-3">
              <span><small>Total</small></span><br>
              <span style="margin-top: -25px"><strong>{{quotation.DocTotal}} {{quotation.DocCurrency}}</strong></span> <br>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-9">
              <span><small>Comentarios del proyecto</small></span><br>
              <base-input v-model="quotation.U_ProjectComments" placeholder="Escribe comentarios de la cotización" style="transform: scale(1.0);transform-origin:left;" inputClasses="input-group-alternative"></base-input>
            </div>
            <div class="col-sm-3">
              <span><small>Avance</small></span><br>
              <multiselect v-model="quotation.U_Percentage" :options="PercentageOptions" label="Description" track-by="Value"></multiselect>
              <!-- <span style="margin-top: -25px"><strong>{{quotation.U_Percentage}}</strong></span> <br> -->
            </div>
          </div>
          <div class="row" style="margin-top:-15px">
            <div class="col-sm-9">
            </div>
            <div class="col-sm-3">
              <base-button v-if="!loadingPatch" tag="a" type="success" class="active" role="button" aria-pressed="true" style="float:right;" @click="saveChanges">Guardar cambios</base-button>
              <center v-if="loadingPatch">
                <img src="img/loader.gif" class="img-responsive" style="width: 50px" />
                <br />
                Guardando cambios...
              </center>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="table-responsive" style="padding-top:10px">
              <base-table thead-classes="thead-light" :data="quotation.DocumentLines">
                <template slot="columns">
                    <th><center>Producto</center></th>
                    <th><center>Cantidad</center></th>
                    <th><center>Precio</center></th>
                    <th><center>Total</center></th>
                    <th></th>
                </template> 
                <template slot-scope="{ row }">
                  <th scope="row">
                      <center>
                        <a style="font-size: 12px">{{ row.ItemCode }} </a> <br>
                        <a style="font-size: 10px">{{ row.ItemDescription }} </a> 
                      </center>
                  </th>
                  <th scope="row">
                    <center>
                      <a style="font-size: 12px">{{ row.Quantity }} {{row.MeasureUnit}}</a>
                    </center>
                  </th>
                  <th scope="row">
                      <center>
                      <a style="font-size: 12px">$ {{ row.Price }} {{row.Currency}}</a>
                      </center>
                  </th>
                  <th scope="row">
                      <center>
                      <a style="font-size: 12px">$ {{ row.LineTotal }} {{row.Currency}}</a>
                      </center>
                  </th>
                </template>
              </base-table>
            </div>
          </div>
        </div>
        <base-loader v-if="!quotation"></base-loader>
      </b-modal>

        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">

        </base-header>

        <div class="container-fluid mt--9">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card shadow">
                      <div class="card-header">
                        <h3>Cotizaciones abiertas</h3>
                      </div>
                      <data-table id="dt_quo_projects" class="pb-5" v-bind="dtQuoProjects"/>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import DTDescription from "@/components/DataTable/DTDescription.vue"
import DTMoney from "@/components/DataTable/DTMoney.vue"
import DTLoader from "@/components/DataTable/DTLoader.vue"
import DTButton from "@/components/DataTable/DTButton.vue"
import BaseLoader from "../components/BaseLoader.vue"
import Event from "@/Event.js";

  import Vue from 'vue'
  import Multiselect from "vue-multiselect";
  import { getAuth } from "firebase/auth";
  import axios from 'axios'
  
  export default {
    components:{
      Multiselect,
      BaseLoader
    },
    created(){
      this.user = getAuth().currentUser;
    },
    mounted(){
      setTimeout(() => {
        this.getOpenQuotes()
      }, 1000);
      Event.listen("Click", (row) =>{
        this.seeQuote(row.DocEntry);
      });
    },
    beforeMount(){
      
    },
    data() {
      return {
        showQuotation: false,
        quotation: null,
        PercentageOptions: [],
        loadingPatch: false,
        dtQuoProjects: {
          data: [] ,
          columns: [
            { 
              title: "Folio", 
              key: "DocNum", 
              type: "number"
            },
            { 
              title: "Cliente", 
              key: "CardName",
              component: DTDescription,
              extraData: { 
                title: "CardName", 
                description: "CardCode" 
              } 
            },
            { 
              title: "Fecha", 
              key: "DocDate",
            },
            { 
              title: "Vencimiento", 
              key: "DocDueDate",
            },
            { 
              title: "Total", 
              key: "DocTotal", 
              type: "number",
              component: DTMoney,
              extraData: {
                money: "DocTotal"
              }
            },
            { 
              title: "Porcentaje", 
              key: "U_Percentage",
              sortable: false
            },
            {
              title: " ",
              sortable: false,
              component: DTButton,
              extraData: {
                text: "Ver Más",
              } 
            }
          ],
          lang: "es",
          sortingMode: "single",
          showDownloadButton: false,          
          loadingComponent: DTLoader,
          isLoading: true,
          defaultPerPage: 100,
          text: {
            previousButtonText: "❮",
            nextButtonText: "❯", 
            searchText: "Buscar"
          },
        },
      }
    },
    methods:{
      getOpenQuotes(){
        axios.get(`/api/quotes/open/projects`).then(response => {
          this.dtQuoProjects.data = response.data.value;
          this.dtQuoProjects.isLoading = false;
        }).catch(error => {
          console.log("🚀 ~ file: QuotationProjects.vue ~ line 58 ~ axios.get ~ error", error)
        });
        axios.get(`/api/user_fields/Percentage`).then(response => {
          this.PercentageOptions = response.data.value[0].ValidValuesMD;
        }).catch(error => {
          console.log("🚀 ~ file: QuotationProjects.vue ~ line 58 ~ axios.get ~ error", error)
        });
        
      },
      seeQuote(DocEntry){
        this.quotation = null;
        this.showQuotation = true;
        axios.get(`/api/quotes/${DocEntry}`).then(response => {
          this.quotation = response.data
          this.quotation.U_Percentage = {
            Value: this.quotation.U_Percentage,
            Description: this.quotation.U_Percentage,
          }
        }).catch(error => {
          console.log("🚀 ~ file: QuotationProjects.vue ~ line 58 ~ axios.get ~ error", error)
        });
      },
      saveChanges(){
        this.loadingPatch = true;
        let json = {
          U_Percentage: this.quotation.U_Percentage.Value,
          U_ProjectComments: this.quotation.U_ProjectComments
        }
        
        axios.patch(`/api/quotes?DocEntry=${this.quotation.DocEntry}`, json).then(response => {
          if(response.data.result === "OK"){
            this.loadingPatch = false;
            this.quotation = null;
            this.showQuotation = false;
            this.$swal.fire({
              title: "Cambios guardados",
              text: "",
              icon: "success",
              showConfirmButton: true,
            }).then(()=>{
              this.getOpenQuotes()
            })
          }
          else{
            this.$swal.fire({
              title: "Error",
              text: response.data.message,
              icon: "error",
              showConfirmButton: true,
            }).then(()=>{
              this.loadingPatch = false;
            })
          }
        }).catch(error => {
          console.log("🚀 ~ file: QuotationProjects.vue ~ line 58 ~ axios.get ~ error", error)
        });
      }
    }
  };
</script>
<style>
#dt_quo_projects> .data-table-pagination {
  grid-area: pagination / pagination / pagination / download;
}
</style>
